import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import QBtn from 'quasar/src/components/btn/QBtn.js';import QSelect from 'quasar/src/components/select/QSelect.js';
import cache from '@/modules/shared/helpers/utils/cache'

export interface TesTablePagination {
  [key: string]: any
}

@Component
export class TesTablePagination extends Vue {
  __getPaginationDiv(h, child) {
    let control
    const
      { rowsPerPage } = this.computedPagination,
      paginationLabel = this.paginationLabel || this.$q.lang.table.pagination,
      paginationSlot = this.$scopedSlots.pagination,
      hasOpts = this.rowsPerPageOptions.length > 1

    child.push(
      h('div', { staticClass: 'q-table__separator col' })
    )

    if (hasOpts === true) {
      child.push(
        h('div', { staticClass: 'q-table__control' }, [
          h('span', { staticClass: 'q-table__bottom-item' }, [
            this.rowsPerPageLabel || this.$q.lang.table.recordsPerPage
          ]),
          h(QSelect, {
            staticClass: 'q-table__select inline q-table__bottom-item',
            props: {
              color: this.color,
              value: rowsPerPage,
              options: this.computedRowsPerPageOptions,
              displayValue: rowsPerPage === 0
                ? this.$q.lang.table.allRows
                : rowsPerPage,
              dark: this.isDark,
              borderless: true,
              dense: true,
              optionsDense: true,
              optionsCover: true
            },
            on: cache(this, 'pgSize', {
              input: pag => {
                this.setPagination({
                  page: 1,
                  rowsPerPage: pag.value
                })
              }
            })
          })
        ])
      )
    }

    if (paginationSlot !== void 0) {
      control = paginationSlot(this.marginalsScope)
    } else {
      control = [
        h('span', rowsPerPage !== 0 ? { staticClass: 'q-table__bottom-item' } : {}, [
          rowsPerPage
            ? paginationLabel(this.firstRowIndex + 1, Math.min(this.lastRowIndex, this.computedRowsNumber), this.computedRowsNumber)
            : paginationLabel(1, this.filteredSortedRowsNumber, this.computedRowsNumber)
        ])
      ]

      if (rowsPerPage !== 0 && this.pagesNumber > 1) {
        const btnProps: any = {
          color: this.color,
          round: true,
          dense: true,
          flat: true
        }

        if (this.dense === true) {
          btnProps.size = 'sm'
        }

        this.pagesNumber > 2 && control.push(
          h(QBtn, {
            key: 'pgFirst',
            props: {
              ...btnProps,
              icon: this.navIcon[0],
              disable: this.isFirstPage
            },
            on: cache(this, 'pgFirst', { click: this.firstPage })
          })
        )

        control.push(
          h(QBtn, {
            key: 'pgPrev',
            props: {
              ...btnProps,
              icon: this.navIcon[1],
              disable: this.isFirstPage
            },
            on: cache(this, 'pgPrev', { click: this.prevPage })
          }),

          h(QBtn, {
            key: 'pgNext',
            props: {
              ...btnProps,
              icon: this.navIcon[2],
              disable: this.isLastPage
            },
            on: cache(this, 'pgNext', { click: this.nextPage })
          })
        )

        this.pagesNumber > 2 && control.push(
          h(QBtn, {
            key: 'pgLast',
            props: {
              ...btnProps,
              icon: this.navIcon[3],
              disable: this.isLastPage
            },
            on: cache(this, 'pgLast', { click: this.lastPage })
          })
        )
      }
    }

    child.push(
      h('div', { staticClass: 'q-table__control' }, control)
    )

    return child
  }
}
